import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  IconButton,
  Drawer,
  List,
  ListItemText,
  Link,
  ListItemButton,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

// NEW: Import the Star icon
import StarIcon from "@mui/icons-material/Star";

// NEW: Import keyframes from @emotion/react (or @emotion/styled)
import { keyframes } from "@emotion/react";

// Simple keyframes that rotate the star
const spinStar = keyframes`
  0% {
    transform: rotate(0deg);
    color: #f9a825; /* gold-ish */
  }
  50% {
    transform: rotate(180deg);
    color: #ffc107; /* slightly lighter gold */
  }
  100% {
    transform: rotate(360deg);
    color: #f9a825;
  }
`;

// You can add 'star: true' to any link that you want to display the star icon
const navLinks = [
  { label: "Features", href: "/features" },
  { label: "FAQ", href: "/faq" },
  { label: "Pricing", href: "/pricing" },
  { label: "Contact Us", href: "/contactus" },
  // NEW: Add a dedicated Trial item with star animation
  { label: "Trial", href: "/book-trial", star: true },
];

const HeaderBar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  return (
    <AppBar position="static" color="default" elevation={2}>
      <Toolbar>
        <Typography
          variant="h6"
          sx={{ flexGrow: 1, fontWeight: "bold", cursor: "pointer" }}
          onClick={() => (window.location.href = "/")}
        >
          BetaZen
        </Typography>

        {/* Desktop Navigation */}
        <Box sx={{ display: { xs: "none", md: "flex" }, gap: 2 }}>
          {navLinks.map(({ label, href, star }) => (
            <Link
              key={label}
              href={href}
              color="inherit"
              underline="none"
              sx={{
                fontSize: "1rem",
                fontWeight: "500",
                position: "relative",
                display: "flex",
                alignItems: "center",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
            >
              {label}
              {star && (
                <StarIcon
                  sx={{
                    ml: 0.5,
                    fontSize: "1.2rem",
                    animation: `${spinStar} 2s linear infinite`,
                  }}
                />
              )}
            </Link>
          ))}
        </Box>

        {/* Mobile Menu Button */}
        <IconButton
          edge="end"
          color="inherit"
          aria-label="menu"
          onClick={toggleDrawer(true)}
          sx={{ display: { xs: "block", md: "none" } }}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>

      {/* Mobile Drawer */}
      <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
        <Box sx={{ width: 250, display: "flex", flexDirection: "column" }}>
          <IconButton
            onClick={toggleDrawer(false)}
            sx={{ alignSelf: "flex-end", m: 1 }}
          >
            <CloseIcon />
          </IconButton>
          <List>
            {navLinks.map(({ label, href, star }) => (
              <ListItemButton key={label} component="a" href={href}>
                {star && (
                  <StarIcon
                    sx={{
                      mr: 1,
                      animation: `${spinStar} 2s linear infinite`,
                    }}
                  />
                )}
                <ListItemText primary={label} />
              </ListItemButton>
            ))}
          </List>
        </Box>
      </Drawer>
    </AppBar>
  );
};

export default HeaderBar;
